/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import { Hideable } from '../..';
import { DropArea } from './dropArea';
import { DropAreaContainer } from './dropAreaContainer';
import { DropAreaImage } from './dropAreaImage';
import { DropAreaText } from './dropAreaText';
const UploadFileButton = forwardRef((props, ref) => {
    const { accept, children, containerStyle, dragChildren, errorHandler, imageUrls = [], isLoading, maxSize, multiple = false, onDelete, onDropSuccess, renderChildrenOnly = false, uploadHandler, } = props;
    const [dropZoneInactive, setDropZoneInactive] = useState(true);
    const fileInput = useRef(null);
    const onFileDrop = (acceptedFiles, fileRejections, event) => {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (acceptedFiles === null || acceptedFiles === void 0 ? void 0 : acceptedFiles.length) {
            if (onDropSuccess) {
                onDropSuccess(acceptedFiles);
            }
            uploadHandler({ file: acceptedFiles[0], name: 'name' });
        }
        if (fileRejections === null || fileRejections === void 0 ? void 0 : fileRejections.length) {
            if (errorHandler) {
                errorHandler(fileRejections.map((fileRejection) => {
                    return `[${fileRejection.file.name}] ` + fileRejection.errors.map((fileError) => {
                        return fileError.message;
                    }).join(', ');
                }));
            }
        }
    };
    const onFileClick = () => {
        (fileInput === null || fileInput === void 0 ? void 0 : fileInput.current) && fileInput.current.click();
    };
    const onImageDelete = (imageId) => (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (onDelete) {
            onDelete(imageId);
        }
    };
    // Allow triggering click of the file input from the parent.
    useImperativeHandle(ref, () => ({
        getFile: () => {
            onFileClick();
        },
    }));
    // RENDER
    const dropAreaImages = imageUrls.filter(imageUrl => !!imageUrl);
    const getDropAreaImages = () => dropAreaImages.map((imageUrl) => (React.createElement(DropAreaImage, { key: imageUrl, imageUrl: imageUrl, onImageDelete: onImageDelete })));
    return (React.createElement(DropAreaContainer, { style: containerStyle },
        React.createElement(DropArea, { accept: accept, disabled: isLoading, maxSize: maxSize, onDragEnter: () => setDropZoneInactive(false), onDragLeave: () => setDropZoneInactive(true), onDrop: onFileDrop }, ({ getRootProps, getInputProps }) => (React.createElement("section", null,
            React.createElement(Hideable, { hide: !renderChildrenOnly },
                React.createElement("div", Object.assign({}, getRootProps(), { onClick: onFileClick, onMouseLeave: () => setDropZoneInactive(true) }),
                    React.createElement("input", Object.assign({}, getInputProps(), { ref: fileInput })),
                    dropZoneInactive ? children : (dragChildren || children))),
            React.createElement(Hideable, { hide: !!renderChildrenOnly },
                React.createElement("div", Object.assign({}, getRootProps(), { onMouseLeave: () => setDropZoneInactive(true) }),
                    React.createElement("input", Object.assign({}, getInputProps())),
                    React.createElement(DropAreaText, { dropZoneInactive: dropZoneInactive, imageCount: dropAreaImages.length, multiple: multiple, uploading: isLoading }, children)))))),
        React.createElement(Hideable, { hide: !renderChildrenOnly },
            React.createElement("div", null, getDropAreaImages()))));
});
// Exporting an arrow function directly doesn't give the component a displayName
UploadFileButton.displayName = 'UploadFileButton';
export { UploadFileButton };
//# sourceMappingURL=uploadFileButton.js.map